import * as appActionKeys from './appActionKeys';

const detectMemberCookie = (userId) => ({
  type: appActionKeys.MEMBER_DETECTION,
  payload: {
    userId,
  },
});

const setActivityLocation = (activityLocation) => ({
  type: appActionKeys.ACTIVITY_LOCATION,
  payload: {
    activityLocation,
  },
});

const setUserType = (userType) => ({
  type: appActionKeys.USER_TYPE,
  payload: {
    userType,
  },
});

export default {
  detectMemberCookie,
  setActivityLocation,
  setUserType,
};



// WEBPACK FOOTER //
// ./src/app/browser/redux/appActions.js